export default __webpack_public_path__ + "static/media/carro.6a8eae48.svg";